<script lang="ts">
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ReportStepMixin extends Vue {
  screen?: ReportScreenEnum;

  /**
   * Whether the partner configured custom data protection texts (label or hint for the data protection checkbox).
   * If so, the default THG contact information text is hidden.
   */
  get hasCustomDataProtectionText(): boolean {
    const settings = ReportModule.partner?.settings;
    return !!(settings?.dataProtectionLabel || settings?.dataProtectionHint);
  }

  setCurrentStep() {
    if (this.screen) {
      ReportModule.setStep(this.screen);
    }
  }

  activateConfirmingRefresh() {
    window.onbeforeunload = function () {
      return confirm("Confirm refresh");
    };
  }

  deactivateConfirmingRefresh() {
    window.onbeforeunload = null;
  }

  mounted() {
    this.setCurrentStep();
    this.activateConfirmingRefresh();
  }

  destroyed() {
    this.deactivateConfirmingRefresh();
  }
}
</script>
